(function () {
  if (window.__vitrineProfessionalMenuBound) return;
  window.__vitrineProfessionalMenuBound = true;

  function setItemState(item, expanded) {
    if (!item) return;
    var toggle = item.querySelector(':scope > div > [data-vitrine-submenu-toggle]');
    var submenu = item.querySelector(':scope > [id]');
    item.classList.toggle('is-open', expanded);
    if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (submenu) submenu.setAttribute('aria-hidden', expanded ? 'false' : 'true');
  }

  function closeItemTree(item) {
    if (!item) return;
    setItemState(item, false);
    item.querySelectorAll('[data-vitrine-menu-item].is-open').forEach(function (child) {
      setItemState(child, false);
    });
  }

  function closeDesktopMenus(except) {
    document.querySelectorAll('.vitrine-native-menu__desktop-item.is-open').forEach(function (item) {
      if (item !== except) closeItemTree(item);
    });
  }

  function closeMobileMenu(menu) {
    if (!menu) return;
    menu.removeAttribute('open');
    menu.querySelectorAll('[data-vitrine-menu-item].is-open').forEach(closeItemTree);
    document.documentElement.classList.remove('vitrine-native-menu-open');
  }

  /* Garante a navegação antes que qualquer script antigo do tema intercepte o clique. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-vitrine-menu-link][href]');
    if (!link) return;

    var rawHref = link.getAttribute('href');
    if (!rawHref || rawHref === '#' || rawHref.indexOf('javascript:') === 0) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target.toLowerCase() === '_blank') return;

    var mobileMenu = link.closest('.vitrine-native-menu--mobile');
    if (mobileMenu) closeMobileMenu(mobileMenu);

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(link.href);
  }, true);

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-vitrine-menu-close]');
    if (closeButton) {
      event.preventDefault();
      closeMobileMenu(closeButton.closest('.vitrine-native-menu--mobile'));
      return;
    }

    var toggle = event.target.closest('[data-vitrine-submenu-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      var item = toggle.closest('[data-vitrine-menu-item]');
      var willOpen = toggle.getAttribute('aria-expanded') !== 'true';

      if (item && item.classList.contains('vitrine-native-menu__desktop-item')) {
        closeDesktopMenus(item);
      } else if (item && item.parentElement) {
        item.parentElement.querySelectorAll(':scope > [data-vitrine-menu-item].is-open').forEach(function (sibling) {
          if (sibling !== item) closeItemTree(sibling);
        });
      }

      setItemState(item, willOpen);
      return;
    }

    if (!event.target.closest('.vitrine-native-menu--desktop')) closeDesktopMenus();
  });

  document.addEventListener('toggle', function (event) {
    if (!event.target.matches('.vitrine-native-menu--mobile')) return;
    document.documentElement.classList.toggle('vitrine-native-menu-open', event.target.open);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.vitrine-native-menu--mobile[open]').forEach(closeMobileMenu);
    closeDesktopMenus();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth < 1025) return;
    document.querySelectorAll('.vitrine-native-menu--mobile[open]').forEach(closeMobileMenu);
  });
})();
